(() => {
  function initHeroSlider(root) {
    const slides = [...root.querySelectorAll('[data-hero-slide]')];
    if (slides.length < 2) return;

    const dotsWrap = root.querySelector('[data-hero-dots]');
    const prevBtn = root.querySelector('[data-hero-prev]');
    const nextBtn = root.querySelector('[data-hero-next]');
    const progress = root.querySelector('[data-hero-progress]');
    const interval = Math.max(3000, Number(root.dataset.interval) || 5000);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

    let index = Math.max(0, slides.findIndex((s) => s.classList.contains('is-active')));
    if (index < 0) index = 0;
    let timer = null;
    let paused = false;
    let touchStartX = 0;
    let touchDeltaX = 0;

    if (dotsWrap) {
      dotsWrap.innerHTML = slides
        .map(
          (_, i) =>
            `<button type="button" class="hero-slider__dot${i === index ? ' is-active' : ''}" data-hero-dot="${i}" role="tab" aria-label="Go to slide ${i + 1}" aria-selected="${i === index}"></button>`
        )
        .join('');
    }

    const dots = dotsWrap ? [...dotsWrap.querySelectorAll('[data-hero-dot]')] : [];

    const setSlide = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        if (active) slide.removeAttribute('tabindex');
        else slide.setAttribute('tabindex', '-1');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
      restartProgress();
    };

    const clearTimers = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const restartProgress = () => {
      if (!progress) return;
      progress.style.transition = 'none';
      progress.style.width = '0%';
      if (reduce || paused) return;
      void progress.offsetWidth;
      progress.style.transition = `width ${interval}ms linear`;
      progress.style.width = '100%';
    };

    const start = () => {
      clearTimers();
      if (reduce || paused) return;
      restartProgress();
      timer = window.setInterval(() => setSlide(index + 1), interval);
    };

    const stop = () => {
      paused = true;
      clearTimers();
      if (progress) {
        progress.style.transition = 'none';
        progress.style.width = '0%';
      }
    };

    const resume = () => {
      paused = false;
      start();
    };

    const go = (next) => {
      setSlide(next);
      if (!paused && !reduce) start();
    };

    prevBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(index - 1);
    });
    nextBtn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      go(index + 1);
    });
    dots.forEach((dot) => {
      dot.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        go(Number(dot.dataset.heroDot));
      });
    });

    // Hover pause only on real pointer devices — mobile mouseenter was freezing the slider.
    if (canHover) {
      root.addEventListener('mouseenter', stop);
      root.addEventListener('mouseleave', resume);
      root.addEventListener('focusin', stop);
      root.addEventListener('focusout', (e) => {
        if (!root.contains(e.relatedTarget)) resume();
      });
    }

    // Swipe on mobile / touch
    root.addEventListener(
      'touchstart',
      (e) => {
        if (!e.touches?.[0]) return;
        touchStartX = e.touches[0].clientX;
        touchDeltaX = 0;
        clearTimers();
      },
      { passive: true }
    );
    root.addEventListener(
      'touchmove',
      (e) => {
        if (!e.touches?.[0]) return;
        touchDeltaX = e.touches[0].clientX - touchStartX;
      },
      { passive: true }
    );
    root.addEventListener(
      'touchend',
      () => {
        const threshold = 40;
        if (Math.abs(touchDeltaX) > threshold) {
          go(touchDeltaX < 0 ? index + 1 : index - 1);
        } else if (!paused && !reduce) {
          start();
        }
        touchStartX = 0;
        touchDeltaX = 0;
      },
      { passive: true }
    );

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        clearTimers();
      } else if (!paused && !reduce) {
        start();
      }
    });

    // Keep autoplay running when the hero is on screen (helps mobile tab restore).
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              if (!paused && !reduce) start();
            } else {
              clearTimers();
            }
          });
        },
        { threshold: 0.2 }
      );
      io.observe(root);
    }

    setSlide(index);
    start();
  }

  const boot = () => {
    document.querySelectorAll('[data-hero-slider]').forEach(initHeroSlider);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
